var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"back"},[_vm._v(" 88.888 ")]),_c('div',{staticClass:"front"},[_vm._v(" "+_vm._s((_vm.value && _vm.value >= 10 ? '' : (_vm.value ? 0 : '')))+_vm._s((_vm.value ? _vm.value : '00.000'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }